import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinSlideoversPpwComponent extends Component {
  @service organisation;
}
